import {
  EPermissionSpecialAuthorization,
  TRequiredPermission,
} from 'src/pages/configuration/permissions/_components/permissions.type'

export class PermissionError extends Error {
  requiredPermission?: TRequiredPermission
  requiredSpecialAuthorization?: EPermissionSpecialAuthorization
  isNetworkBlocked?: boolean

  constructor(options: {
    requiredPermission?: TRequiredPermission
    requiredSpecialAuthorization?: EPermissionSpecialAuthorization
    isNetworkBlocked?: boolean
  }) {
    super('Permission denied')
    this.name = 'PermissionError'
    this.requiredPermission = options.requiredPermission
    this.requiredSpecialAuthorization = options.requiredSpecialAuthorization
    this.isNetworkBlocked = options.isNetworkBlocked
  }
}
